export default {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO'
}
